import React, { memo, useEffect, useState } from "react";
import generateAvatarUrl from "../../app/utils/generateAvatarUrl";
import { getMarketHeroImageUrl } from "../../utils/marketSubjectDisplay";

/**
 * Market profile image from catalog subject, or generated letter avatar.
 */
const MarketHeroAvatar = memo(function MarketHeroAvatar({
  market,
  label,
  size = 36,
  className = "market-hero-avatar",
}) {
  const text = (label || market?.title || "").trim() || "Market";
  const preferred = getMarketHeroImageUrl(market, text);
  const fallback = generateAvatarUrl(text);
  const [src, setSrc] = useState(preferred);

  useEffect(() => {
    setSrc(preferred);
  }, [preferred]);

  const dim = { width: size, height: size, minWidth: size, minHeight: size };

  return (
    <img
      src={src}
      alt=""
      className={className}
      style={dim}
      width={size}
      height={size}
      loading="lazy"
      decoding="async"
      onError={() => {
        if (src !== fallback) setSrc(fallback);
      }}
    />
  );
});

export default MarketHeroAvatar;
